import React from 'react';
import PropTypes from 'prop-types';
import HubContent from './HubContent'; // Resolve can't fix this. It's a bug in eslint-plugin-import

/*
 * BrandHub can be for a (sub)theme as a brand, it provides the same functionality.
 */
const BrandHub = ({ data }) => {
  return <HubContent data={data} />;
};

BrandHub.defaultProps = {
  data: PropTypes.shape({
    logoUrl: null,
  }),
};

BrandHub.propTypes = {
  data: PropTypes.shape({
    name: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    logoUrl: PropTypes.string,
    slug: PropTypes.string.isRequired,
  }),
};

export default BrandHub;
